module.exports = __webpack_public_path__ + "img/hopways.eb0825b2.webp";